import { ListItemText } from "@mui/material";
import React, { useState, useEffect } from "react";
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";

const ConsentScripts = (props) => {

  const [allowed, setAllowed] = useState(getCookieConsentValue());

  useEffect(() => {    
    if (allowed !== 'true') { return }
    gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted'
    });
  });

  return (<CookieConsent
            location="bottom"
            buttonText="Allow"
            ariaAcceptLabel="Allow"
            enableDeclineButton={true}
            declineButtonText="Deny"
            ariaDeclineLabel="Deny"
            onAccept={() => setAllowed('true')}
            onDecline={() => setAllowed('false')}
          >
            <ListItemText><strong>This website uses cookies</strong></ListItemText>
            <ListItemText>We use cookies and similar technologies to maintain the functionality of the application. You consent to the use of such technologies by clicking Agree, by clicking any link or button outside of this notice, or by continuing to use the Application in any other way.</ListItemText>
          </CookieConsent>
  );
}

export default ConsentScripts;